/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CompetenceCompetenceidLangsId202,
  DeleteApiV1CompetenceCompetenceidLangsId401,
  DeleteApiV1CompetenceCompetenceidLangsId404,
  DeleteApiV1CompetenceCompetenceidLangsId500,
  DeleteApiV1CompetenceCompetenceidLangsIdMutationResponse,
  DeleteApiV1CompetenceCompetenceidLangsIdPathParams,
} from "../../types/competenceIdiomasController/DeleteApiV1CompetenceCompetenceidLangsId.ts";

export const deleteApiV1CompetenceCompetenceidLangsIdPathParamsSchema =
  z.object({
    competenceId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1CompetenceCompetenceidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1CompetenceCompetenceidLangsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1CompetenceCompetenceidLangsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CompetenceCompetenceidLangsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CompetenceCompetenceidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CompetenceCompetenceidLangsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CompetenceCompetenceidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CompetenceCompetenceidLangsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CompetenceCompetenceidLangsId500>;

export const deleteApiV1CompetenceCompetenceidLangsIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1CompetenceCompetenceidLangsId202Schema,
  ) as unknown as ToZod<DeleteApiV1CompetenceCompetenceidLangsIdMutationResponse>;
